module.exports = __webpack_public_path__ + "img/logoGrandCapital.19a0b26b.svg";